import React, { useEffect, useState } from 'react';
import { Form, Button, Row, Col, Alert } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import services from '../../services';
import { toast } from 'react-toastify';

const ReSyncAccount = ({ show, onHide, authEmail }) => {
    const [formData, setFormData] = useState({
        email: authEmail,
        fromDate: '',
        toDate: '',
    });
    const [validated, setValidated] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const formatDateToDDMMYYYY = (dateString) => {
        if (!dateString) return '';
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        const form = e.currentTarget;
        e.preventDefault();
        e.stopPropagation();

        if (form.checkValidity() === false) {
            setValidated(true);
            return;
        }

        setValidated(true);
        setErrorMessage('');
        setSuccessMessage('');

        try {
            const payload = {
                ...formData,
                fromDate: formatDateToDDMMYYYY(formData.fromDate),
                toDate: formatDateToDDMMYYYY(formData.toDate),
            };

            const response = await services.email.SYNC_OLD_MAIL(payload);

            setSuccessMessage('Resynced successfully!');
            setTimeout(() => {
                onHide();
            }, 1000);
            setLoading(false);

        } catch (error) {
            toast.error(error?.response?.data?.error);
            setErrorMessage(error.response?.data?.message || 'Failed to resync account');
            setLoading(false);
        }
    };


    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Body>
                {loading ? (
                    <div className="d-flex justify-content-center align-items-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div className="mt-2">
                        <h2>Sync Old Mail</h2>
                        <Form noValidate validated={validated}>
                            <Form.Group controlId="email" className="mb-3">
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    placeholder="Enter Email"
                                    required
                                    disabled
                                />
                                <Form.Control.Feedback type="invalid">Please provide a valid Email.</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="fromDate" className="mb-3">
                                <Form.Label>From</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="fromDate"
                                    value={formData.fromDate}
                                    onChange={handleInputChange}
                                    placeholder="Enter Start Date"
                                    required
                                    min={new Date().toISOString().split('T')[0]}
                                />
                                <Form.Control.Feedback type="invalid">Please provide a valid Start Date.</Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group controlId="toDate" className="mb-3">
                                <Form.Label>To</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="toDate"
                                    value={formData.toDate}
                                    onChange={handleInputChange}
                                    placeholder="Enter End Date"
                                    required
                                    min={formData.fromDate}
                                    max={(() => {
                                        if (!formData.fromDate) return undefined;
                                        const d = new Date(formData.fromDate);
                                        d.setDate(d.getDate() + 2);
                                        return d.toISOString().split('T')[0];
                                    })()}

                                />
                                <Form.Control.Feedback type="invalid">Please provide a valid End Date.</Form.Control.Feedback>
                            </Form.Group>
                        </Form>
                    </div>
                )}
            </Modal.Body>
            {!loading && (
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>
                        Close
                    </Button>
                    <Button variant="primary" type="button" onClick={handleSubmit}>
                        Submit
                    </Button>
                </Modal.Footer>
            )}
        </Modal>
    );
};

export default ReSyncAccount;
